// Clean blue connector org chart from the company profile (content.md 公司架构):
//   董事长·总经理 → 副总经理 → {行政, 船运, 货运, 贸易事业部, 财务部}
// Built as responsive flex boxes + SVG-free CSS connectors so it reflows on
// mobile (stacks) and animates in with a stagger. Owned by Agent D.
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import { fadeUp, stagger, revealViewport } from "../motion/variants";

const DEPT_KEYS = ["admin", "shipping", "freight", "trade", "finance"] as const;

function TopBox({ label, accent }: { label: string; accent?: boolean }) {
  return (
    <motion.div
      variants={fadeUp}
      className={`mx-auto w-full max-w-xs rounded-[var(--radius-md)] px-6 py-4 text-center font-zh font-bold ${
        accent
          ? "bg-gradient-to-br from-[var(--brand-primary)] to-[var(--brand-azure)] text-white shadow-[var(--shadow-card)]"
          : "border border-[var(--brand-azure)] bg-white text-[var(--brand-azure-text)]"
      }`}
    >
      {label}
    </motion.div>
  );
}

export default function OrgChart() {
  const { t } = useTranslation("about");

  return (
    <motion.div
      variants={stagger}
      initial="hidden"
      whileInView="visible"
      viewport={revealViewport}
      className="flex flex-col items-center"
    >
      <TopBox label={t("org.chairman")} accent />

      {/* connector */}
      <div className="h-8 w-px bg-[var(--brand-tint-2)]" aria-hidden="true" />

      <TopBox label={t("org.viceGm")} />

      {/* connector down into the department row */}
      <div className="h-8 w-px bg-[var(--brand-tint-2)]" aria-hidden="true" />

      <motion.ul
        variants={stagger}
        className="grid w-full grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5"
      >
        {DEPT_KEYS.map((key) => (
          <motion.li
            key={key}
            variants={fadeUp}
            className="flex items-center justify-center rounded-[var(--radius-md)] border border-[var(--brand-tint)] bg-[var(--brand-tint-3)] px-4 py-5 text-center font-zh font-medium text-[var(--ink)] transition-colors hover:border-[var(--brand-azure)] hover:bg-white"
          >
            {t(`org.departments.${key}`)}
          </motion.li>
        ))}
      </motion.ul>
    </motion.div>
  );
}
